import * as React from 'react';

import ControlledRangeSelect from 'modules/discovery/components/range-select/ControlledRangeSelect';

import { __t, applyTranslations } from 'utils/language';
import { abbrNum } from 'utils/helper/common';
import { FOLLOWERS_STEP_SELECTOR, transformSteps } from 'modules/discovery/utils/discovery';

import './discovery-content-filters-followers.scss';

import type { DiscoveryContentFilters, DiscoveryFilterMinMax } from 'types';

applyTranslations(require('./discovery-content-filters-followers.i18n.json'));

type Props = {
  filters: DiscoveryContentFilters,
  handleFiltersUpdate: (a: any) => void
};

const msgKey = 'discovery_content_filters_followers';

class DiscoveryContentFiltersFollowers extends React.PureComponent<Props> {
  static defaultProps = {
    filters: {},
    handleFiltersUpdate: () => {}
  };

  handleFollowersSliderChangeComplete = (range: DiscoveryFilterMinMax) => {
    const { followers: propsFollowers } = this.props.filters;

    this.handleUpdate({
      followers: {
        ...propsFollowers,
        ...range,
        transformed: {
          ...transformSteps(range, FOLLOWERS_STEP_SELECTOR)
        }
      }
    });
  };

  handleUpdate = (result: any): void => {
    const { handleFiltersUpdate } = this.props;

    if (handleFiltersUpdate) {
      handleFiltersUpdate(result);
    }
  };

  renderFollowersSlider(): React.ReactNode {
    const { filters } = this.props;

    const valueTransformer = (range) => {
      const transformedReach = transformSteps(range, FOLLOWERS_STEP_SELECTOR);

      const valueMin = abbrNum(transformedReach.min, { decimal: 1 });
      const valueMax = abbrNum(transformedReach.max, { decimal: 1 });
      return `${valueMin} – ${valueMax}`;
    };

    return (
      <div className="discovery-content-filters-followers__section">
        <ControlledRangeSelect
          key="discovery-content-filters-followers--range"
          title={__t(`${msgKey}.labels.followers`)}
          tooltip={__t(`${msgKey}.tooltips.followers`)}
          titleValueTransformer={valueTransformer}
          data={filters.followers}
          onChangeComplete={this.handleFollowersSliderChangeComplete}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="discovery-content-filters-followers">
        {this.renderFollowersSlider()}
      </div>
    );
  }
}

export default DiscoveryContentFiltersFollowers;
